import { ApiResponse, TokenData, InitialTouchPoint } from '../models';
import * as http from './http';
import ApiService from './service';

export class InitialTouchPointService extends ApiService {
  public async loadAllInitialTouchPoint() {
    const url = `${this.apiDomain}/api/initial-touch-point`;

    const resposne = await http.get<ApiResponse<InitialTouchPoint[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createInitialTouchPoint(data: InitialTouchPoint) {
    const url = `${this.apiDomain}/api/initial-touch-point`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateInitialTouchPoint(data: InitialTouchPoint, id?: string) {
    const url = `${this.apiDomain}/api/initial-touch-point/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteInitialTouchPoint(id?: string) {
    const url = `${this.apiDomain}/api/initial-touch-point/${id}`;

    const response = await http.remove<ApiResponse<InitialTouchPoint>>(
      url,
      this.store
    );
    return response.data;
  }

  public async createCombinedInitialTouch(
    id: string,
    initialTouchPointId: string
  ) {
    const url = `${this.apiDomain}/api/initial-touch-point/${id}/combined`;

    const response = await http.post<ApiResponse<string[]>>(
      url,
      {
        initialTouchPointId,
      },
      this.store
    );
    return response.data;
  }

  public async deleteCombined(id: string, initialTouchPointId: string) {
    const url = `${this.apiDomain}/api/initial-touch-point/${id}/combined/${initialTouchPointId}`;

    const response = await http.remove<ApiResponse<string[]>>(url, this.store);
    return response.data;
  }
}
